<template>
    <o-table :title="$t('sandoz.export_jobs')" ref="tableList" url="/api/sandoz/export_jobs" :enable-new="false"
             :enable-delete="false" :enable-edit="false" :enable-view="true"
             default-sort-by-direction="desc" default-sort-by="id">
        <template slot="filter">
            <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                <o-filter-select :items="stateList" :title="$t('sandoz.status')" column="status"></o-filter-select>
            </o-filter>
        </template>
        <template slot="head">
            <o-table-header column="id">{{$t('core.id')}}</o-table-header>
            <o-table-header column="created_at">{{$t('sandoz.date')}}</o-table-header>
            <o-table-header column="status">{{$t('sandoz.status')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.created_at | formatDatetime }}</td>
            <td>{{ props.item.status ? $t('sandoz.' + props.item.status) : '' }}</td>
        </template>
    </o-table>
</template>

<script>
    export default {
        data: () => ({
            stateList: []
        }),
        created() {
            this.stateList = [
                {value: 'running', text: this.$i18n.t('sandoz.running')},
                {value: 'failed', text: this.$i18n.t('sandoz.failed')},
                {value: 'successful', text: this.$i18n.t('sandoz.successful')},
            ]
        }
    }
</script>
